<div class="top-section service-page">

    <section class="healthcare-banner instool aashi">
        <div class="container">
            <div class="row hero-img-wrapper zmc">
                <div class="col-lg-7 col-md-7 col-sm-7  col-12 service-heading">
                    <div class="headtext">
                        <h1>Microsoft 365</h1>
                        <p>Microsoft 365 (formerly known as Office 365) is a comprehensive suite of productivity tools
                            and cloud-based services that help individuals and organizations work efficiently and
                            collaboratively.</p>

                            <a class="ar_contect-industries-header" 
                            routerLink="/contact-us.html"><span>Contact Us</span></a>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                    <div class="right-img frontend-heroimg">
                        <img src="../../../assets/images/services/image-2-removebg-preview.png"
                            loading="lazy" alt="Ecommerce Website Development Service Header Image">
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<section class="services-row">
    <div class="container">
        <!-- <app-services-content-point [firstMAtchData]="firstMAtch"></app-services-content-point> -->

        <div class="softeare-developemnt-isv-main">
            <div class="row">
                <div class="col-lg-12 headingsec">
                    <h2>Microsoft 365 Core Applications</h2>
                    <p>It combines the traditional Office suite of applications with advanced cloud services,
                        collaboration tools, and intelligent capabilities. Here's an overview of its functionality and
                        key features</p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 softeare-developemnt-isv">
                    <ul>
                        <li class="mobi">
                            <div class="img-box-isv">
                                <img src="../../../assets/images/services/banner-1.jpg" loading="lazy"
                                    alt="Ecommerce Application Development">

                            </div>
                        </li>
                        <li>
                            <h3>Word</h3>
                            <p>Word processing application for creating, editing, and formatting text documents with
                                features like templates, editing tools, and real-time collaboration.
                            </p>
                            <h3>Excel</h3>
                            <p>Spreadsheet application for data analysis and visualization with formulas, charts, pivot
                                tables, and other analytical tools.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 softeare-developemnt-isv">
                    <ul>
                        <li>
                            <h3>PowerPoint</h3>
                            <p>Presentation application for creating dynamic slideshows with multimedia support,
                                templates, and design tools.</p>
                        </li>
                        <li>
                            <h3>Outlook</h3>
                            <p>Email and calendar application with features like email management, scheduling, and task
                                tracking.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="quote-box" style="    background-color: #0d052a;">
    <div class="container">
        <div class="row">
            <div class="col-md-9">
                <h4>Are You Ready To Discuss Your Project With Us?</h4>
            </div>
            <div class="col-md-3">
                <button routerLink="/hire-react-js-developers.html">Hire Our Experts</button>
            </div>
        </div>
    </div>
</section> -->
<section class="services-row services-row-new white_bg border-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Collaboration and Communication Services it use</h2>
                <!-- <p>We use best technologies to develop User Interface applications for every industry. </p> -->
            </div>
            <div class="col-lg-12 smart-software-product-isv frontend-tech ">
                <ul>
                    <li>
                        <img src="../../../assets/images/services/teams-removebg-preview.png" alt="HTML">
                        <h3>Microsoft Teams</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/sharepoint-removebg-preview (1).png" alt="CSS">
                        <h3>SharePoint</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/yammer-removebg-preview.png" alt="Javascript">
                        <h3>Yammer</h3>
                    </li>
                    <!-- <li>
                        <img src="../../../../assets/images/services/common/react.png" alt="React">
                        <h3>React</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/angular.png" alt="Angular">
                        <h3>Angular</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/Vue.png" alt="Vue">
                        <h3>Vue</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/sass.png" alt="Scss">
                        <h3>Scss</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/bootstrap.png" alt="Bootstrap">
                        <h3>Bootstrap</h3>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="services-row services-row-new white_bg border-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Cloud Storage and Management Services it use</h2>
                <!-- <p>We use best technologies to develop User Interface applications for every industry. </p> -->
            </div>
            <div class="col-lg-12 smart-software-product-isv frontend-tech ">
                <ul>
                    <li>
                        <img src="../../../assets/images/services/one-drive-removebg-preview.png" alt="HTML">
                        <h3>OneDrive</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/exchange-removebg-preview.png" alt="CSS">
                        <h3>Exchange Online</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/azure-removebg-preview.png" alt="Javascript">
                        <h3>Azure Active Directory</h3>
                    </li>
                    <!-- <li>
                        <img src="../../../../assets/images/services/common/react.png" alt="React">
                        <h3>React</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/angular.png" alt="Angular">
                        <h3>Angular</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/Vue.png" alt="Vue">
                        <h3>Vue</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/sass.png" alt="Scss">
                        <h3>Scss</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/bootstrap.png" alt="Bootstrap">
                        <h3>Bootstrap</h3>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</section>



<!-- <app-why-choose-us></app-why-choose-us> -->

<section class="services-row services-row-new">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Productivity and Security Services it use</h2>
                <!-- <p>Here’s what you get when you choose us as your preferred business partner:</p> -->
            </div>
        </div>
        <div class="row  uses-box">
            <div class="col-lg-7 col-md-7 col-sm-12 whychoose-isv uses-conent">
                <ul>
                    <li>
                        <h3>Power Automate</h3>
                        <p>Workflow automation tool for streamlining processes and integrating different applications and services
                        </p>
                    </li>
                    <li>
                        <h3>Power Apps</h3>
                        <p>Low-code development platform for creating custom applications tailored to business needs.</p>
                    </li>
                    <li>
                        <h3>Power BI</h3>
                        <p> Business intelligence tool for data visualization and analysis, helping organizations make data-driven decisions.</p>
                    </li>
                    <li>
                        <h3>Microsoft Defender</h3>
                        <p>Advanced threat protection service that helps secure email, documents, and devices against threats.</p>
                    </li>
                    <li>
                        <h3>Compliance and Governance</h3>
                        <p>Tools for managing data compliance, regulatory requirements, and data governance..</p>
                    </li>
                    <li>
                        <h3>Post-Release Support</h3>
                        <p> We provide endless post-release support for your products even after the deployment without
                            any further cost.</p>
                    </li>
                </ul>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-12 img-box-container img-content">
                <div class="img-box-why-chosse">
                    <img src="../../../assets/images/services/banner-2.png" loading="lazy"
                        alt="Product Web Development">
                </div>
            </div>
        </div>
    </div>

</section>











